import { useState } from "react";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { http } from "@/lib/api";

export default function RecoverAccess() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await http.post("/premium/resend", { email });
      setDone(data.message);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Adresse email invalide.");
    }
    setLoading(false);
  };

  return (
    <div className="px-4 max-w-xl mx-auto py-20">
      <p className="font-mono text-xs uppercase tracking-widest text-amber-600">Accès Premium</p>
      <h1 className="mt-3 font-serif text-3xl sm:text-4xl font-bold text-[#0B131E]">Retrouver mon accès</h1>
      <p className="mt-3 text-gray-600 leading-relaxed">Vous avez perdu votre lien ? Indiquez l'adresse email utilisée lors du paiement : nous vous renvoyons le lien de chaque escapade achetée.</p>
      {done ? (
        <div data-testid="recover-success" className="mt-8 flex gap-3 rounded-2xl bg-emerald-50 border border-emerald-100 p-5 text-emerald-900">
          <CheckCircle2 className="w-5 h-5 shrink-0" /><p className="text-sm leading-relaxed">{done} Pensez à vérifier vos courriers indésirables.</p>
        </div>
      ) : (
        <form onSubmit={submit} data-testid="recover-form" className="mt-8 flex flex-col sm:flex-row gap-3">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vous@exemple.fr"
            data-testid="recover-email-input" className="flex-1 h-12 px-4 rounded-xl border-2 border-gray-200 bg-white text-base focus:outline-none focus:border-amber-500 transition-colors" />
          <button type="submit" disabled={loading} data-testid="recover-submit-btn"
            className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-full bg-[#0B131E] text-white font-semibold hover:bg-amber-600 disabled:opacity-60 transition-colors">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />} Renvoyer mon lien
          </button>
        </form>
      )}
      <p className="mt-8 text-sm text-gray-500">Toujours bloqué ? Écrivez-nous à <a href="mailto:contact@wanderlust.fr" className="text-amber-700 underline">contact@wanderlust.fr</a> avec la date de votre achat.</p>
    </div>
  );
}
